import * as React from "react";
import { Button, Confirm, useNotify, useRecordContext, useRefresh } from "react-admin";
import { Delete } from "@mui/icons-material";
import ApiClient from "../../ApiClient";
import API from "../../Routes";

export const EmployeeGDPRErasureButton = ({ record: recordProp, size = "small" }) => {
  const [open, setOpen] = React.useState(false);
  const notify = useNotify();
  const refresh = useRefresh();
  const recordContext = useRecordContext();
  const record = recordProp || recordContext;
  const employeeId = record?.employeeId || record?.id;

  if (!employeeId) {
    return null;
  }

  return (
    <>
      <Button
        label="GDPR DELETION"
        onClick={() => setOpen(true)}
        color="error"
        size={size}
      >
        <Delete />
      </Button>
      <Confirm
        isOpen={open}
        title="Delete employee data"
        content={`Are you sure you want to permanently erase GDPR data for employee ${employeeId}?`}
        onConfirm={async () => {
          setOpen(false);
          try {
            await ApiClient.fetch(API.EMPLOYEES.GDPR_ERASURE(employeeId), {
              method: "POST",
            });
            notify(`Employee ${employeeId} GDPR data has been deleted successfully`);
            refresh();
          } catch (error) {
            notify(
              `Failed to trigger GDPR deletion for employee ${employeeId}: ${
                error?.message || error
              }`,
              { type: "error" }
            );
          }
        }}
        onClose={() => setOpen(false)}
      />
    </>
  );
};
